module.exports = __webpack_public_path__ + "img/logo-hugol.81a3e4dc.png";